module.exports = __webpack_public_path__ + "img/safety3.8d66f477.png";